var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wp-mini-header",class:{ 'wp-mini-header_bordered': _vm.notEmpty }},[_c('div',{staticClass:"wp-mini-header__title",class:{ 'wp-mini-header__title_colored': _vm.colored }},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"wp-mini-header__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }